import React from 'react';
import styled, {css} from 'styled-components';
import {useHotkeys} from 'react-hotkeys-hook';
import Draggable from 'react-draggable';

import {PopupButton, CloseIcon} from './shared';


const PopupContainer = styled.div`
  background: white;
  box-shadow: 0px 16px 30px rgba(0, 0, 0, 0.24);
  border-radius: 8px;
  color: white;
  resize: both;
  overflow: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  touch-action: none;

  ${({noSize}) => !noSize && css`
    width: 50%;
    min-height: 283px;
    min-width: 375px;
    max-height: 80vh;
    max-width: 80vw;
  `}

  ${({fullSize}) => fullSize && css`
    height: 80vh;
    width: 80vw;
  `}

  ${({theme}) => theme.mediaQueries.mobileL} {
    height: 20vh;
  }

  font-size: 14px;
`;

const PopupHeader = styled.div`
  background: ${({color}) => color || '#006DAA'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  cursor: grabbing;
  font-size: 16px;
`;
const PopupFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  background: ${({color}) => color || '#006DAA'};
`;

export const DraggablePopup = ({
  innerRef,
  close,
  headerContent,
  footerContent,
  children,
  fullSize=false,
  noSize=false,
  className,
  color,
  fixed,
  positionProps={},
  showHeader=true,
  showFooter=true,
}) => {

  useHotkeys('esc', close, [close]);

  const draggableProps = fixed
    ? {positionOffset: {x: 0, y: '-50vh'}}
    : {};

  const popupContainerProps = fixed
    ? {style: {position: 'fixed', zIndex: 10000000}}
    : {};

  return (
    <Draggable handle=".handle" {...draggableProps}>
      <PopupContainer ref={innerRef} onClick={e => e.stopPropagation()} noSize={noSize} fullSize={fullSize} className={className} {...popupContainerProps}>
        <PopupHeader className="handle" color={color}>
          {headerContent}
          <PopupButton style={{display: 'flex'}}>
            <CloseIcon style={{marginRight: '0px'}} onTouchEnd={close} onClick={close} />
          </PopupButton>
        </PopupHeader>
        {children}
        <PopupFooter className="draggable-popup-footer" color={color}>
          {footerContent}
          <PopupButton onClick={close}><CloseIcon/> Close</PopupButton>
        </PopupFooter>
      </PopupContainer>
    </Draggable>
  )
};

const Wrapper = styled.div`
  position: fixed;
  z-index: 10000000;
  width: 50%;
  resize: horizontal;
  overflow: auto;

  ${({noSize}) => noSize && css`
    width: auto;
    overflow: initial;
  `}
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const DraggableAndResizablePopup = ({children, noSize}) => {
  return (
    <Draggable handle={'.handle'}>
      <Wrapper noSize={noSize}>
        <InnerWrapper className={'handle'} >
          {children}
        </InnerWrapper>
      </Wrapper>
    </Draggable>
  );
};
